/*
 * Copyright ish group pty ltd. All rights reserved. https://www.ish.com.au
 * No copying or use of this code is allowed without permission in writing from ish.
 */

import { Tag } from '@api/model';
import { IAction } from '../../models/IshAction';
import { GET_TAGS_FULFILLED } from 'src/js/redux/actions/PortalWebsite';

const Initial: Tag[] = [];

export const tagsReducer = (state = Initial, action: IAction): Tag[] => {
  switch (action.type) {
    case GET_TAGS_FULFILLED:
      return [
        ...state,
        ...action.payload
      ];

    default:
      return state;
  }
};
